import { render, staticRenderFns } from "./crudCustomersGroups.vue?vue&type=template&id=f411e1a0"
import script from "./crudCustomersGroups.vue?vue&type=script&lang=js"
export * from "./crudCustomersGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports